
// 用来定义常用的一些常量
// 使用时 直接引入对应名称

// 按钮状态
export const BtnStatus = {
  0: 'gray',
  1: 'green',
  2: 'red'
}
export const BtnName = {
  0: 'Live',
  1: 'Live',
  2: 'Stop'
}

export const nameColor = {
  0: 'grayColor',
  1: 'whiteColor',
  2: 'redColor'
}
// 账号类型
export const SocialType = [
  {
    key: 'all',
    value: 'all',
    label: 'all',
    isChecked: true
  },
  {
    value: 'Facebook',
    key: 'F',
    label: 'Facebook',
    isChecked: true
  },
  {
    value: 'YouTube',
    key: 'Y',
    label: 'YouTube',
    isChecked: true
  },
  {
    value: 'YiLive',
    key: 'Z',
    label: 'YiLive',
    isChecked: true
  },
  {
    value: 'Periscope',
    key: 'S',
    label: 'Periscope',
    isChecked: true
  },
  {
    value: 'Twitter',
    key: 'Twitter',
    label: 'Twitter',
    isChecked: true
  },
  {
    value: 'Twitch',
    key: 'T',
    label: 'Twitch',
    isChecked: true
  },
  {
    value: 'Instagram',
    key: 'I',
    label: 'Instagram',
    isChecked: true
  },
  {
    value: 'KuaiShou',
    key: 'K',
    label: 'KuaiShou',
    isChecked: true
  },
  {
    value: 'Others',
    key: 'O',
    label: 'Others',
    isChecked: true
  }
]
// 设备状态 advanced control
export const StatusSelect = [
  {
    value: 'living',
    label: 'live',
    isChecked: true,
    color: 'red'
  }, {
    value: 'online',
    label: 'online',
    isChecked: true,
    color: 'green'
  }, {
    value: 'offline',
    label: 'offline',
    isChecked: true,
    color: 'gray'
  }
]
// 设备状态 source control
export const StatusSourceSelect = [
  {
    value: 'living',
    label: 'live',
    isChecked: true,
    color: 'red'
  }, {
    value: 'noCamera',
    label: 'noSource',
    isChecked: true
  },
  {
    value: 'online',
    label: 'online',
    isChecked: true,
    color: 'green'
  }, {
    value: 'offline',
    label: 'offline',
    isChecked: true,
    color: 'gray'
  }
]

// sourceControl设备类型
export const SourceTypeSelect = [
  {
    value: 'all',
    label: 'all',
    isChecked: true
  },
  {
    value: 'pack',
    label: 'TVUPack',
    isChecked: true
  },
  {
    value: 'anywhere',
    label: 'TVUAnywhere',
    isChecked: true
  },
  {
    value: 'token',
    label: 'Token',
    isChecked: true
  },
  // {
  //     value: 'globalGrid',
  //     label: 'GlobalGrid',
  //     isChecked: true
  // },
  {
    value: 'gridPack',
    label: 'Grid-Pack',
    isChecked: true
  },
  {
    value: 'gridSdi',
    label: 'Grid-SDI',
    isChecked: true
  }
]
// 设备类型
export const TypeSelect = [
  {
    value: 'all',
    label: 'all',
    isChecked: true
  },
  {
    value: 'pack',
    label: 'TVUPack',
    isChecked: true
  },
  {
    value: 'anywhere',
    label: 'TVUAnywhere',
    isChecked: true
  },
  {
    value: 'gridPack',
    label: 'Grid-Pack',
    isChecked: true
  },
  {
    value: 'gridSdi',
    label: 'Grid-SDI',
    isChecked: true
  },
  {
    value: 'ext',
    label: 'Ext',
    isChecked: true
  },
  {
    value: 'token',
    label: 'TToken',
    isChecked: false
  },
  {
    value: 'gridViaToken',
    label: 'GridViaToken',
    isChecked: true
  },
  {
    value: 'globalGrid',
    label: 'GlobalGrid',
    isChecked: true
  }
]

// 设备类型
export const AdvancedTypeSelect = [
  {
    value: 'all',
    label: 'all',
    isChecked: true
  },
  {
    value: 'pack',
    label: 'TVUPack',
    isChecked: true
  },
  {
    value: 'anywhere',
    label: 'TVUAnywhere',
    isChecked: true
  },
  {
    value: 'gridPack',
    label: 'Grid-Pack',
    isChecked: true
  },
  {
    value: 'gridSdi',
    label: 'Grid-SDI',
    isChecked: true
  },
  {
    value: 'ext',
    label: 'Ext',
    isChecked: true
  },
  {
    value: 'token',
    label: 'TToken',
    isChecked: false
  },
  {
    value: 'gridViaToken',
    label: 'GridViaToken',
    isChecked: true
  },
  {
    value: 'globalGrid',
    label: 'GlobalGrid',
    isChecked: true
  },
  {
    value: 'glink',
    label: 'GLink',
    isChecked: true
  },
  {
    value: 'rtil',
    label: 'RTIL',
    isChecked: true
  }
]

// sourcelist 中type对应的websoket数据中的key
export const SourceTypeInKey = {
  Peerlist: 'PackPeerManager',
  GridPeerList: 'GridPeerManager', // Grid-Pack Grid-SDI
  LocalSDIList: 'LocalSDIPeerManager',
  LocalPeerList: 'LocalExternalPeerManager',
  RemotePeerList: 'RemoteExternalPeerManager',
  GLinkList: 'GLinkPeerManager',
  RtilList: 'AgoraPeerManager'
}

export const myResouceMapIcon = {
  onlineImg: require('@/assets/img/map/source_online.png'),
  sourceImg: require('@/assets/img/map/source_live.png'),
  receiverImg: require('@/assets/img/map/receiver_live.png'),
  logoImg: require('@/assets/img/logo_thumbnail.png'),
  notScale: require('@/assets/img/map/notScale.png'),
  notInScale: require('@/assets/img/map/notInScale.png')
}

export const DefaultImgByStatus = {
  T: {
    type: 'TVUPack',
    0: require('@/assets/img/offlinePng.png'),
    1: require('@/assets/img/null.png'),
    3: require('@/assets/img/null.png'),
    4: require('@/assets/img/logot.png')
  },
  X: {
    type: 'TVUGrid',
    0: require('@/assets/img/offlinePng.png'),
    1: require('@/assets/img/null.png'),
    3: require('@/assets/img/null.png'),
    4: require('@/assets/img/logot.png'),
    1000: require('@/assets/img/logot.png'),
    1001: require('@/assets/img/unknown.png')
  },
  Ext: {
    type: 'Ext',
    img: require('@/assets/img/ext.jpg')
  },
  YouTube: {
    type: 'YouTube',
    img: require('@/assets/img/youtube.jpg')
  },
  TVUGrid: {
    type: 'TVUGrid',
    0: require('@/assets/img/offlinePng.png'),
    1: require('@/assets/img/null.png'),
    3: require('@/assets/img/null.png')
  },
  LocalSDI: {
    type: 'LocalSDI',
    0: require('@/assets/img/offlinePng.png'),
    1: require('@/assets/img/null.png')
  },
  SMPTE2022: {
    type: 'SMPTE2022',
    img: require('@/assets/img/SMPTE.png')
  },
  FILE: {
    type: 'FILE',
    img: require('@/assets/img/ext.jpg')
  },
  GLink: {
    0: require('@/assets/img/offlinePng.png'),
    1: require('@/assets/img/null.png'),
    3: require('@/assets/img/null.png'),
    4: require('@/assets/img/logot.png')
  },
  Rtil: {
    0: require('@/assets/img/offlinePng.png'),
    1: require('@/assets/img/null.png'),
    3: require('@/assets/img/null.png'),
    4: require('@/assets/img/logot.png')
  }
}

// 筛选排序 by online off name
export const SelectBySort = {
  onlineFirst: {
    label: 'Online',
    value: 'onlineFirst',
    data: true
  },
  liveFirst: {
    label: 'Live',
    value: 'liveFirst',
    data: true
  },
  nameFirst: {
    label: 'Name',
    value: 'nameFirst',
    data: true
  }
}
export const SelectBySorts = [
  {
    label: 'Online',
    value: 'onlineFirst',
    data: true
  },
  {
    label: 'Live',
    value: 'liveFirst',
    data: true
  },
  {
    label: 'Name',
    value: 'nameFirst',
    data: true
  }
]

// record模块里面的icon图标
export const IconList = {
  0: require('@/assets/img/downloading.png'),
  1: require('@/assets/img/paused.png'),
  2: require('@/assets/img/task.png'),
  3: require('@/assets/img/downloading.png'),
  4: require('@/assets/img/transcoding.png'),
  5: require('@/assets/img/exclam_ico.png'),
  6: require('@/assets/img/Record_folder.png'),
  7: require('@/assets/img/autosync_ico.png')
}

export const VoipImage = {
  0: require('@/assets/img/calling.png'),
  1: require('@/assets/img/connecting.png'),
  2: require('@/assets/img/endCall.png')
}

// mysource 状态
export const MySourceStatus = [
  {
    value: 'all',
    label: 'all',
    isChecked: false
  },
  {
    value: 'online',
    label: 'available',
    isChecked: false,
    color: 'green'
  }, {
    value: 'noCamera',
    label: 'noSource',
    isChecked: false
  }, {
    value: 'living',
    label: 'live',
    isChecked: false,
    color: 'red'
  }, {
    value: 'offline',
    label: 'offline',
    isChecked: false,
    color: 'gray'
  }
]

export const MySReceiverStatus = [
  {
    value: 'all',
    label: 'all',
    isChecked: false
  },
  {
    value: 'online',
    label: 'available',
    isChecked: false,
    color: 'green'
  }, {
    value: 'living',
    label: 'live',
    isChecked: false,
    color: 'red'
  }, {
    value: 'offline',
    label: 'offline',
    isChecked: false,
    color: 'gray'
  }, {
    value: 'sort',
    label: 'dynamicsorting',
    isChecked: false
  }
]

// mysource 类型
export const MySourceType = [
  {
    value: 'all',
    label: 'all',
    isChecked: false
  },
  {
    value: 'pack',
    label: 'TVUPack',
    isChecked: false
  },
  {
    value: 'anywhere',
    label: 'TVUAnywhere',
    isChecked: false
  },
  {
    value: 'gridPack',
    label: 'Grid-Pack',
    isChecked: false
  },
  {
    value: 'gridSdi',
    label: 'Grid-SDI',
    isChecked: false
  },
  {
    value: 'ext',
    label: 'Ext',
    isChecked: false
  },
  {
    value: 'gridViaToken',
    label: 'viaToken',
    isChecked: false
  },
  {
    value: 'globalGrid',
    label: 'globalGrid',
    isChecked: false
  },
  {
    value: 'token',
    label: 'TToken',
    isChecked: false
  }
]

// 设备类型
export const SourceType = [
  {
    label: 'all',
    value: 'all'
  },
  {
    label: 'SMPTE2022',
    value: 'SMPTE2022'
  },
  {
    label: 'Ext',
    value: 'Ext'
  },
  {
    label: 'YouTube',
    value: 'YouTube'
  }
]

// mysource 类型
export const AccountDeviceType = [
  {
    value: 'all',
    label: 'all',
    isChecked: true
  },
  {
    value: 'receiver',
    label: 'receiver',
    isChecked: true
  },
  {
    value: 'pack',
    label: 'TVUPack',
    isChecked: true
  },
  {
    value: 'anywhere',
    label: 'TVUAnywhere',
    isChecked: true
  },
  {
    value: 'gridPack',
    label: 'Grid-Pack',
    isChecked: true
  },
  {
    value: 'gridSdi',
    label: 'Grid-SDI',
    isChecked: true
  },
  {
    value: 'token',
    label: 'TToken',
    isChecked: true
  }
]

// 用户角色
export const RoleType = {
  2: 'support',
  3: 'admin',
  4: 'user'
}
export const ManageRoleType = {
  2: 'supportManager',
  1: 'systemAdmin',
  3: 'admin',
  4: 'user'
}

// setting/device
export const DeviceType = [
  {
    value: 'all',
    label: 'all',
    isChecked: true
  },
  {
    value: 'pack',
    label: 'TVUPack',
    isChecked: true
  },
  {
    value: 'anywhere',
    label: 'TVUAnywhere',
    isChecked: true
  },
  {
    value: 'gridPack',
    label: 'Grid-Pack',
    isChecked: true
  },
  {
    value: 'gridSdi',
    label: 'Grid-SDI',
    isChecked: true
  },
  {
    value: 'receiver',
    label: 'receiver',
    isChecked: true
  },
  {
    value: 'token',
    label: 'TToken',
    isChecked: true
  }
]

export const DeviceAddress = [
  {
    label: 'all',
    value: 'all',
    isChecked: true
  },
  {
    label: 'automatic',
    value: 'automatic',
    isChecked: true
  },
  {
    label: 'manual',
    value: 'manual',
    isChecked: true
  },
  {
    label: 'noPosition',
    value: 'noPosition',
    isChecked: true
  }
]

export const BitrateList = [
  {
    label: 'Auto',
    value: 0
  },
  {
    label: '1.2Mb/s',
    value: 1.2
  },
  {
    label: '2.4Mb/s',
    value: 2.4
  },
  {
    label: '6Mb/s',
    value: 6
  },
  {
    label: '12Mb/s',
    value: 12
  },
  {
    label: '24Mb/s',
    value: 24
  },
  {
    label: '30Mb/s',
    value: 30
  }
]

export const ThumnailImg = {
  0: require('@/assets/img/offline.png'),
  1: require('@/assets/img/null.png'),
  2: require('@/assets/img/logot.png'),
  3: require('@/assets/img/null.png'),
  Ext: require('@/assets/img/newEXT.png'),
  YouTube: require('@/assets/img/newYoutobe.png'),
  SMPTE2022: require('@/assets/img/SMPTE.png'),
  SRT: require('@/assets/img/SRT.png'),
  1000: require('@/assets/img/offline_rs.png'),
  1001: require('@/assets/img/unknown.png')
}

export const SocialPlatform = [
  { name: 'lang.Facebook', type: 'F', icon: '#icon-facebook2' },
  { name: 'lang.Instagram', type: 'I', icon: '#icon-instagram2' },
  { name: 'lang.YiLive', type: 'Z', icon: '#icon-yizhibo' },
  { name: 'lang.YouTube', type: 'Y', icon: '#icon-youtubeautored', icon2: '#icon-youtubemanualred' },
  { name: 'lang.Periscope', type: 'S', icon: '#icon-Periscope1' },
  { name: 'lang.Twitter', type: 'Twitter', icon: '#icon-Twitter' },
  { name: 'lang.Twitch', type: 'T', icon: '#icon-twitch' },
  { name: 'lang.KuaiShou', type: 'K', icon: '#icon-kuaishou3' },
  { name: 'lang.Others', type: 'O', icon: '#icon-Rtmpgreen' }
]
export const ChannelList = [
  { name: 'Import social media accounts', nameKey: 'ImportAccounts', type: 'social', title: 'BindSocialAccounts' },
  // { name: 'Grid', type: '' },
  { name: 'HLS', nameKey: 'HLS', type: 'OutputExtra-HLS', title: 'HLSSettings' },
  { name: 'ISSP', nameKey: 'ISSP', type: 'OutputExtra-ISSP', title: 'ISSPSettings', icon: '#icon-issp' },
  { name: 'ProMPEG', nameKey: 'ProMPEG', type: 'OutputExtra-PROMPEG', title: 'PROMPEGSettings' },
  { name: 'SRT', nameKey: 'SRT', type: 'OutputExtra-SRT', title: 'SRTSettings', icon: '#icon-SRT' },
  { name: 'Zixi', nameKey: 'Zixi', type: 'OutputExtra-ZiXi', title: 'ZiXiSettings' }
]

export const outputExampleImg = {
  global: ['#icon-facebook2', '#icon-youtubeautored', '#icon-Rtmpgreen'],
  china: ['#icon-SRT', '#icon-kuaishou3', '#icon-Rtmpgreen']
}
export default {
  BtnStatus,
  StatusSelect,
  TypeSelect,
  AdvancedTypeSelect,
  BtnName,
  VoipImage,
  SourceTypeInKey,
  myResouceMapIcon,
  DefaultImgByStatus,
  SelectBySort,
  IconList,
  MySourceStatus,
  MySourceType,
  SelectBySorts,
  SourceType,
  RoleType,
  ManageRoleType,
  AccountDeviceType,
  DeviceType,
  DeviceAddress,
  BitrateList,
  ThumnailImg,
  SocialPlatform,
  ChannelList,
  outputExampleImg
}
